import React from "react";

interface IRentalOrderPriceTrackingsMachineGroupRootProps {
    children: React.ReactNode;
}

export const RentalOrderPriceTrackingsMachineGroupRoot = (props: IRentalOrderPriceTrackingsMachineGroupRootProps) => {
    return <div className="rental-order-price-trackings-machine-group-root">{props.children}</div>;
};
